import {
  UPDATE_APP_NAME,
  HYDRATE_DOMAIN,
  REPLACE_APP_NAME_DATA,
  FIELD_VALIDATION_CHECK,
  RECEIVE_META_DATA,
  DOMAIN_REMOVED,
} from './actions';
import { SAVE_APP_NAME } from '../../../actions';

const appName = (state = {}, action) => {
  switch (action.type) {
    case HYDRATE_DOMAIN:
      return {
        ...state,
        [action.appname]: {
          meta: {
            ...action.meta,
          },
        },
      };

    case UPDATE_APP_NAME:
      return {
        ...state,
        [action.appname]: {
          ...state[action.appname],
          meta: {
            ...state[action.appname].meta,
            ...action.meta,
          },
          modified: true,
        },
      };

    case RECEIVE_META_DATA: {
      return {
        ...state,
        [action.appname]: {
          meta: {
            ...action.data,
          },
        },
      };
    }

    case REPLACE_APP_NAME_DATA: {
      return {
        [action.appname]: {
          ...state[action.previusAppname],
          modified: false,
        },
      };
    }

    case SAVE_APP_NAME:
      return {
        ...state,
        [action.appname]: {
          ...state[action.appname],
          modified: false,
        },
      };

    case FIELD_VALIDATION_CHECK:
      return {
        ...state,
        [action.appname]: {
          ...state[action.appname],
          validations: {
            ...action.validations,
            ...state[action.appname].validations,
            [action.attr]: action.invalid,
          },
          modified: true,
        },
      };

    case DOMAIN_REMOVED:
    default:
      return state;
  }
};

export default appName;
